export default __webpack_public_path__ + "static/media/jaegar.03fae1a6.svg";